import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { logout } from '../actions/user';
import { JurisdictionCount, JurisdictionMenu } from '../config/jurisdiction';
import Layout from './Layout';

const mapDispatchToProps = (dispatch: any) => ({
  logout: (value: any) => dispatch(logout(value)),
});

const mapStateToProps = (user: any) => ({ user });

const PageIndex = (props: any) => {
  useEffect(() => {
    // let user = window.localStorage.getItem("user");
    // if (user) {
    //   return
    // } else {
    //   props.history.push('/login')
    // }
  });

  return (
    <div>
      <Layout
        page={JurisdictionCount()}
        history={props.history}
        logout={props.logout}
        menu_item={JurisdictionMenu()}
        match={props.match}
      />
    </div>
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageIndex);
